import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import { InvestmentsProvider } from './hooks/useInvestments';
import { PortfolioProvider } from './hooks/usePortfolio';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import MyPage from './components/MyPage';
import AssetManagementPage from './pages/AssetManagementPage';
import InvestmentListPage from './pages/InvestmentListPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import ContactPage from './pages/ContactPage';
import AboutPage from './pages/AboutPage';
import NoticePage from './pages/NoticePage';
import LoadingOverlay from './components/LoadingOverlay';
import './App.css';

function App() {
  const location = useLocation();
  const { isAuthenticated, isLoading, isInitialized, user } = useAuth();

  // 로딩 중일 때
  return (
    <PortfolioProvider>
      <InvestmentsProvider>
        <div className="App">
          <LoadingOverlay
            isVisible={isLoading}
            message={isInitialized ? '로그인 중...' : 'Tripistocka를 불러오는 중...'}
          />
          <Navigation key={`nav-${isAuthenticated ? 'auth' : 'guest'}-${user?.id || 'none'}`} />
          
          <main className="app-main page-transition" key={location.pathname}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route 
                path="/login" 
                element={
                  isAuthenticated ? <Navigate to="/" replace /> : <LoginPage />
                } 
              />
              <Route 
                path="/register" 
                element={
                  isAuthenticated ? <Navigate to="/" replace /> : <RegisterPage />
                } 
              />
              <Route 
                path="/mypage" 
                element={
                  <ProtectedRoute>
                    <MyPage />
                  </ProtectedRoute>
                } 
              />
              <Route path="/asset" element={<AssetManagementPage />} />
              <Route path="/investments" element={<InvestmentListPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/notice" element={<NoticePage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>

          <Footer />
        </div>
      </InvestmentsProvider>
    </PortfolioProvider>
  );
}

export default App;
